import getMeta from '@atlassian/jira-get-meta';
import { PUBSUB_DEFAULT_HOST } from '../constants/pubsub.tsx';

export const getDefaultPubSubHost = (): string =>
	getMeta('ajs-fabric-realtime-url') || PUBSUB_DEFAULT_HOST;

export const buildChannelString = (cloudId: string, projectId: string | number) =>
	`ari:cloud:jira:${cloudId}:project/${projectId}`;
